export const hasFilterValue = (value) => {
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === 'string') return value.trim().length > 0;

  return value !== undefined && value !== null && value !== false;
};

const countValues = (...values) => values.filter(hasFilterValue).length;

export const selectDateActiveCount = (state) => {
  const filter = state.filterStore;

  return countValues(filter.dateRange, filter.dateRangeField);
};

export const selectSettingsActiveCount = (state) => {
  const filter = state.filterStore;

  return countValues(filter.relatedToExpired, filter.valueCheckedStage);
};

export const selectPeopleActiveCount = (state) => {
  const filter = state.filterStore;

  return countValues(
    filter.valueWorker,
    filter.valueExecuter,
    filter.valueCreator,
    filter.valueCompany,
    filter.valueStatus
  );
};

export const selectAddressActiveCount = (state) => {
  const filter = state.filterStore;

  return countValues(
    filter.valueDistrict,
    filter.valueAddrStreet,
    filter.valueAddrBuilding,
    filter.valueAddrPorch,
    filter.valueAddrFloor,
    filter.valueAddrTypeFlat,
    filter.valueAddrFlat
  );
};

export const selectLifecycleActiveCount = (state) => {
  const filter = state.filterStore;

  return countValues(
    filter.valueStageFlat,
    filter.valueStageCurrentFlat,
    filter.valueAcceptanceStatusesFlat
  );
};

export const selectServiceActiveCount = (state) => {
  const filter = state.filterStore;

  return countValues(
    filter.valueService,
    filter.valueSubservice,
    filter.immediate,
    filter.expiredOnly
  );
};

export const selectAdditionalActiveCount = (state) => {
  const filter = state.filterStore;

  return countValues(
    filter.valueMethodCreatingRequest,
    filter.valuePriorityRequest,
    filter.valuePhone,
    filter.valueRating,
    filter.retry,
    filter.internal,
    filter.badWork,
    filter.waiting,
    filter.attachmentFilter,
    filter.valueClientName,
  );
};

export const selectPaidOrdersActiveCount = (state) => {
  const filter = state.filterStore;

  return countValues(
    filter.valuePaymentState,
    filter.chargeable,
    filter.isOrder
  );
};

export const selectWarrantyActiveCount = (state) => {
  const filter = state.filterStore;

  return countValues(
    filter.valueWarrantyOrg,
    filter.warranty,
    filter.notWarranty,
    filter.possWarranty
  );
};

export const selectTotalActiveCount = (state) =>
  selectSettingsActiveCount(state) +
  selectDateActiveCount(state) +
  selectPeopleActiveCount(state) +
  selectServiceActiveCount(state) +
  selectAddressActiveCount(state) +
  selectWarrantyActiveCount(state) +
  selectLifecycleActiveCount(state) +
  selectPaidOrdersActiveCount(state) +
  selectAdditionalActiveCount(state);
